import MUIThead from '@mui/material/TableHead';
import React from 'react';

import { propsMapper } from '~/common/components/PropertyMappers/propsMapper';

type TheadProps = React.ComponentProps<typeof MUIThead>;

const Thead = React.forwardRef<any, TheadProps>(
  ({ children, ...props }, ref) => {
    return (
      <MUIThead ref={ref} {...propsMapper(props)}>
        {children}
      </MUIThead>
    );
  },
);

Thead.displayName = 'Thead';

export default Thead;
